<mat-card>
  <mat-card-header *ngIf="images">
     <mat-card-title class="popupHeader">
       <div class="mat-card-header-text" i18n>
         Attachments
       </div>
     </mat-card-title>
  </mat-card-header>

  <mat-card-content>
    <div class="attachmentBox">
    <mat-spinner *ngIf="loading" class="loader" mode="indeterminate"></mat-spinner>
    <img [hidden]="loading" (load)="onLoad()" [src]="source" class="imgBox" />
  </div>
  </mat-card-content>

  <mat-card-actions [hidden]="loading">
    <div class="buttonContent">
      <button class="buttonLeft" *ngIf = "imgCount > 1" mat-icon-button color="primary" (click)="prevImage()"><mat-icon>chevron_left</mat-icon></button>
      <p class="atchCount" [hidden]="loading">{{currentImg}} / {{imgCount}}</p>
      <button class="buttonRight" *ngIf = "imgCount > 1" mat-icon-button color="primary" (click)="nextImage()"><mat-icon>chevron_right</mat-icon></button>
    </div>
  </mat-card-actions>
</mat-card>